import { createContext, useContext } from "react";

const FilePreviewContext = createContext({});

export const FilePreviewContextProvider = FilePreviewContext.Provider;
export const FilePreviewContextConsumer = FilePreviewContext.Consumer;

export const useFilePreviewContext = () => useContext(FilePreviewContext);

export default FilePreviewContext;
